export const GET_FILES = "GET_FILES";
export const MOVE_FILE_TO_ARCHIEVE = "MOVE_FILE_TO_ARCHIEVE";
export const SET_ARCHIVES = "SET_ARCHIVES";
export const SET_AUDIT_RESULTS = "SET_AUDIT_RESULTS";
export const SET_REMINDER = "SET_REMINDER";
export const SET_REMINDER_ACTION = "SET_REMINDER_ACTION";
export const SET_REMINDER_ARCHIVE = "SET_REMINDER_ARCHIVE";
export const SET_REMINDER_ACTION_ARCHIVE = "SET_REMINDER_ACTION_ARCHIVE";
export const SET_LOADING = "SET_LOADING";
export const SET_MAPPED_RULES = "SET_MAPPED_RULES";
export const SET_ACTIVE_FILES = "SET_ACTIVE_FILES";

export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_LOGIN = "SET_LOGIN";
export const SET_ROLE = "SET_ROLE";

export const SET_BID_REQUESTS = "SET_BID_REQUESTS";
export const SET_OPEN_ORDERS = "SET_OPEN_ORDERS";
export const SET_PREVIOUS_ORDERS = "SET_PREVIOUS_ORDERS";